module.exports = __webpack_public_path__ + "assets/img/ic-nodate.d6951620.svg";